import type { Route } from '@application/types';

export const BREEDER_APPLICATIONS_ALERT_EXCLUDED_ROUTES: Route[] = [
  'mtLanding',
  'mtProfile',
  'mtOnboarding',
];
